import state from './moduleOnboardState.js';
import mutations from './moduleOnboardMutations.js';
import actions from './moduleOnboardActions.js';
import getters from './moduleOnboardGetters.js';

export default {
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters,
};
